import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { Link } from "react-router";
import { translate } from "../../localization";
import { FilterCategory } from "./Browse";
import styles from "./List.module.scss";

interface TableData {
  id: string;
  row1: string;
  row2: string;
  row3: string;
  row4: string;
  row5: string;
}

interface ListProps {
  category: FilterCategory;
  data: TableData[];
}

const List = ({ category, data }: ListProps) => {
  const i18n = translate();
  const columnHelper = createColumnHelper<TableData>();
  const columns = [
    columnHelper.accessor("row1", {
      header: i18n.browse.listColumns.column1[category],
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("row2", {
      header: i18n.browse.listColumns.column2[category],
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("row3", {
      header: i18n.browse.listColumns.column3[category],
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("row4", {
      header: i18n.browse.listColumns.column4[category],
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("row5", {
      header: i18n.browse.listColumns.column5[category],
      cell: (info) => info.getValue(),
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (data.length === 0) {
    return null;
  }

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead className={styles.header}>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id} className={styles.row}>
              {row.getVisibleCells().map((cell) => (
                <td
                  key={cell.id}
                  className={styles.cell}
                  title={cell.getValue() as string}
                >
                  <Link to={`/browse/${category}/${row.original.id}`}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </Link>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default List;
